import { render } from "./AddManufacturer.vue?vue&type=template&id=f0bea5cc"
import script from "./AddManufacturer.vue?vue&type=script&lang=js"
export * from "./AddManufacturer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Projects/Vue/one-invoice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__